import axios from '@/api/axios'
import { resourceConstructor } from '@/api'

const constructFullUrl = resourceConstructor('batch')

export default {
  getBatches: ({ params } = {}) => axios.get(constructFullUrl(''), { params }),
}
